var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-content" },
    [
      _vm.data.selected.group
        ? _c("dashboard-map", {
            attrs: {
              countries: _vm.countries,
              "country-code": _vm.selectedCountry,
            },
            on: { "country-clicked": _vm.handleCountryClicked },
          })
        : _vm._e(),
      _vm.data.selected.group
        ? _c("div", { staticClass: "container-fluid row w-100" }, [
            _c("div", { staticClass: "col-6" }, [
              _vm.displayedOutages.length
                ? _c("div", { staticClass: "card-container" }, [
                    _c("div", { staticClass: "row-wrapper" }, [
                      _c("div", { staticClass: "row-title bold" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("scheduledMajorOutages")) + " "
                        ),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link",
                          on: {
                            click: function ($event) {
                              return _vm.handleToggleViewAll()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.viewButtonText) + " ")]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shouldDisplayTable,
                            expression: "shouldDisplayTable",
                          },
                        ],
                        staticClass: "tabel-wrapper",
                      },
                      [
                        _c("div", { staticClass: "table-scroll col-12 p-0" }, [
                          _c("table", { staticClass: "table" }, [
                            _c("thead", { staticClass: "stickyHeader" }, [
                              _c("tr", [
                                _c("th", { staticClass: "tab" }, [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("plantAbbreviation")) +
                                          " / " +
                                          _vm._s(_vm.$t("unit")) +
                                          " / " +
                                          _vm._s(_vm.$t("country")) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _c(
                                  "th",
                                  {
                                    staticClass: "inline-flex",
                                    attrs: { colspan: "6" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("plannedDuration")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "inline-flex",
                                    attrs: { colspan: "2" },
                                  },
                                  [
                                    _vm._v(" " + _vm._s(_vm.$t("cost")) + " "),
                                    _c("column-sorting", {
                                      staticClass: "m-0",
                                      attrs: {
                                        fields: ["cost"],
                                        "active-sort": _vm.activeSort,
                                      },
                                      on: { sort: _vm.sort },
                                    }),
                                  ],
                                  1
                                ),
                                _c("th", { staticClass: "inline-flex tab" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("description")) + " "
                                  ),
                                ]),
                                _c("th", { attrs: { colspan: "2" } }, [
                                  _vm._v(" " + _vm._s(_vm.$t("score")) + " "),
                                ]),
                                _c("th", { attrs: { colspan: "2" } }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("daysToGo")) + " "
                                  ),
                                ]),
                                _c("th", { attrs: { colspan: "2" } }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("outageId")) + " "
                                  ),
                                ]),
                                _c("th", { attrs: { colspan: "2" } }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("outageTitle")) + " "
                                  ),
                                ]),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.displayedOutages,
                                function (plant, index) {
                                  return _c("tr", { key: index }, [
                                    _c("td", [
                                      _vm._v(
                                        " " +
                                          _vm._s(plant.plantName) +
                                          " / " +
                                          _vm._s(plant.unitName) +
                                          " / " +
                                          _vm._s(plant.countryName) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", { attrs: { colspan: "6" } }, [
                                      _vm._v(
                                        " " + _vm._s(plant.startDate) + " - "
                                      ),
                                      _c("br"),
                                      _vm._v(" " + _vm._s(plant.endDate) + " "),
                                    ]),
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v(" " + _vm._s(plant.cost) + " k€ "),
                                    ]),
                                    _c("td", { staticClass: "tab" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(plant.outageDescription) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(Math.floor(plant.score)) +
                                          " "
                                      ),
                                    ]),
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v(
                                        " " + _vm._s(plant.daysToGo) + " "
                                      ),
                                    ]),
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v(
                                        " " + _vm._s(plant.outageId) + " "
                                      ),
                                    ]),
                                    _c("td", { attrs: { colspan: "2" } }, [
                                      _vm._v(
                                        " " + _vm._s(plant.outageTitle) + " "
                                      ),
                                    ]),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm.displayedOutages && _vm.displayedOutages.length
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.shouldDisplayTable,
                                expression: "!shouldDisplayTable",
                              },
                            ],
                            staticClass: "card-wrapper",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row-wrapper pt-2 pb-2 row-wrapper--with-padding",
                              },
                              [
                                _c("div", { staticClass: "col-4 bold" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("unit")) +
                                      " / " +
                                      _vm._s(_vm.$t("country")) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "col-3 bold" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("plannedDuration")) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "col-2 bold" }, [
                                  _vm._v(" " + _vm._s(_vm.$t("cost")) + " "),
                                ]),
                                _c("div", { staticClass: "col-3 bold" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("description")) + " "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._l(_vm.displayedOutages, function (outage) {
                              return _c(
                                "div",
                                {
                                  key: outage.sid,
                                  staticClass: "card-options",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "card-description" },
                                    [
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-4" },
                                          [
                                            _c("div", { staticClass: "bold" }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(outage.plantName) +
                                                  " / " +
                                                  _vm._s(outage.unitName) +
                                                  " "
                                              ),
                                            ]),
                                            _c("dashboard-flag", {
                                              staticClass: "p-0",
                                              attrs: {
                                                "country-code":
                                                  outage.countryCode,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "col-3" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(outage.startDate) +
                                              " - " +
                                              _vm._s(outage.endDate) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "bold col-2" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(outage.cost) + " k€ "
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "col-3" }, [
                                          _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              attrs: { for: "outageTitle" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(outage.outageTitle) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ])
                : _c("div", { staticClass: "card-container text-center" }, [
                    _vm._v(" " + _vm._s(_vm.$t("noMajorOutages")) + " "),
                  ]),
            ]),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "clock-wrapper" }, [
                _c("div", { staticClass: "clock-navbar" }, [
                  _c("span", { staticClass: "pl-3" }, [
                    _vm._v(_vm._s(_vm.$t("outageClock"))),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "clock-container",
                    attrs: { id: "chart-container" },
                  },
                  [_c("outage-clock", { attrs: { "is-embedded": true } })],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c("loading", {
        attrs: { active: _vm.loading, "can-cancel": false },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }